import { useEffect, useRef } from "react";
import Secondary from "../../_app/layouts/Secondary";
import { useAuthSession, useJWTLogout, useLogout } from "../hooks";
import { UITypography } from "../../_app/components";
import { createStylesheet } from "../../_app/utils/styles";

function Logout() {
  const { data: session, isFetching } = useAuthSession();
  const logout = useLogout();
  const hasLoggedOut = useRef(false);
  const isImpersonated = Boolean(session?.act);

  // Run the logout (signOut + clear context/storage + redirect) in an effect — doing it during
  // render updates ContextProvider mid-render and triggers React's setState-in-render warning.
  useEffect(() => {
    if (isFetching || isImpersonated || hasLoggedOut.current) return;
    hasLoggedOut.current = true;
    logout(true);
  }, [isFetching, isImpersonated, logout]);

  if (isImpersonated) return <LogoutImpersonatedUser />;
  return null;
}

function LogoutImpersonatedUser() {
  const classes = useStyles();
  useJWTLogout();
  return (
    <Secondary className={classes.ctr}>
      <UITypography>Logging out masqueraded user...</UITypography>
    </Secondary>
  );
}

const useStyles = createStylesheet((theme) => ({
  ctr: {
    display: "flex",
    width: "100%",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default Logout;
